import React, { useState } from 'react';

import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';

import { contactUsAsQnA } from 'apis/mainApi';

function ContactUs() {
  const { register, handleSubmit } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  const [phoneNumber, setPhoneNumber] = useState('');

  const onSubmit = async (data) => {
    const dataToSubmit = { ...data };

    const isAgreementChecked = document.querySelector('#agree').checked;
    if (!isAgreementChecked) {
      return Swal.fire({
        icon: 'warning',
        title: '개인 정보 수집 이용에 동의해주세요.',
      });
    }

    dataToSubmit.agreement = 1;

    Swal.fire({
      icon: 'info',
      title: '이용 문의를 남기시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '문의하기',
      cancelButtonText: '취소',
    }).then(async (value) => {
      if (value.isConfirmed) {
        await contactUsAsQnA(dataToSubmit)
          .then((response) => {
            if (response.data.success) {
              Swal.fire({
                icon: 'success',
                title: '이용 문의를 전송하였습니다.',
              }).then(() => window.location.reload());
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: 'error',
              title: '이용 문의를 보낼 수 없습니다.',
              html: `
                [ERROR] ${error.message}<br>
                잠시 후 다시 시도해주세요. 오류가 지속되면 고객센터로 연락바랍니다.
              `
            });
          })
      } else {
        Swal.close();
      }
    });    
  };

  return (
    <section className="contactus wrap" id="hash-contact">
      <div className="flex-box">
        <div className="flex-left">
          <div className="wrap-title">
            <h2 lang="en">Contact us</h2>
            <p>이용에 궁금한 점이 있다면 문의해주세요.</p>
          </div>
        </div>
        <div className="flex-right">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-wrap">
              <div className="input-type">
                <input type="text" placeholder="이름" {...register('name', { required: true })} />
              </div>
              <div className="input-type">
                <input
                  type="text"
                  placeholder="연락처(숫자만 입력해주세요.)"
                  value={phoneNumber}
                  {...register('phone', { required: true })}
                  onChange={(e) => {
                    const value = e.target.value;
                    const onlyNumber = value.replace(/[^0-9]/g, '');
                    setPhoneNumber(onlyNumber);
                  }}
                />
              </div>
              <div className="input-type">
                <input
                  type="text"
                  placeholder="유입경로"
                  {...register('funnel', { required: true })}
                />
              </div>
              <div className="input-type">
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="8"
                  placeholder="문의내용"
                  {...register('content', { required: true })}
                />
              </div>
              <div className="privacy">
                <div className="scroll">
                  <p>
                    공유디자이너랩 (이하 “회사”)는 이용자의 개인정보를
                    중요시하며, '정보통신망 이용촉진 및 정보보호 등에 관한 법률'
                    등 관계법령에 의거하여 개인정보를 관리 및 보호하고 있습니다.
                  </p>
                  <h3>1. 개인정보의 수집·이용목적</h3>
                  <p>
                    회사는 수집한 개인정보를 다음의 목적을 위해 이용합니다. 그
                    외에 목적으로는 사용되지 않으며, 제 3자에게 제공되지
                    않습니다.
                  </p>
                  <h3>2. 수집하는 개인정보 항목</h3>
                  <p>
                    회사는 예약 문의, 이용 문의 등을 위해 아래와 같은 개인정보를
                    수집하고 있습니다.
                  </p>
                  <ul className="line-list">
                    <li>필수항목 : 이름, 연락처, 문의내용</li>
                    <li>선택항목 : 유입경로</li>
                  </ul>
                  <table cellPadding="0" cellSpacing="0" className="table">
                    <tbody>
                      <tr>
                        <th>개인정보 수집 항목</th>
                        <th>사유</th>
                      </tr>
                      <tr>
                        <td>이름</td>
                        <td>회사가 문의 대상자를 파악하기 위함</td>
                      </tr>
                      <tr>
                        <td>연락처</td>
                        <td>문의사항에 대한 답변을 위함</td>
                      </tr>
                      <tr>
                        <td>유입경로</td>
                        <td>회사를 알게 된 경로를 파악하기 위함</td>
                      </tr>
                      <tr>
                        <td>문의내용</td>
                        <td>문의내용을 파악하기 위함</td>
                      </tr>
                    </tbody>
                  </table>
                  <h3>3. 개인정보의 보유 및 이용기간</h3>
                  <p>
                    원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는
                    법정보유기간(5년) 이후에는 해당 정보를 지체 없이 파기합니다.
                  </p>
                </div>
                <div className="agree">
                  <input type="checkbox" id="agree" name="agree" style={{ appearance: 'none' }} />
                  <label htmlFor="agree">
                    개인정보 수집 및 이용에 대한 동의
                  </label>
                </div>
              </div>
              <button type="submit" className="btn-submit">
                문의하기
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
